// Shared display-formatting helpers for profile pages (public + account).

/**
 * Format a rate + billing period as "₦40,000 per month".
 * Falls back to a friendly message when no rate is available.
 */
export const formatRate = (rate, period = "hour", fallback = "Rate on request") => {
  const numericRate = Number(rate);
  if (!rate || Number.isNaN(numericRate)) return fallback;
  return `₦${numericRate.toLocaleString()} per ${period}`;
};

/**
 * Normalise any Nigerian phone variant to +234XXXXXXXXXX for display.
 *   08012345678    → +2348012345678
 *   2348012345678  → +2348012345678
 *   +2348012345678 → +2348012345678
 */
/**
 * Format a timestamp as "Joined 5 hours ago", "Joined 3 days ago", etc.
 * Falls back to a short date once it's more than a month old.
 */
export const formatJoinedDate = (dateString) => {
  if (!dateString) return null;
  const joined = new Date(dateString);
  if (Number.isNaN(joined.getTime())) return null;

  const seconds = Math.floor((Date.now() - joined.getTime()) / 1000);
  if (seconds < 60) return "Joined just now";

  const units = [
    { label: "year", secs: 31536000 },
    { label: "month", secs: 2592000 },
    { label: "day", secs: 86400 },
    { label: "hour", secs: 3600 },
    { label: "minute", secs: 60 },
  ];

  for (const { label, secs } of units) {
    const value = Math.floor(seconds / secs);
    if (value >= 1) {
      return `Joined ${value} ${label}${value > 1 ? "s" : ""} ago`;
    }
  }
  return "Joined just now";
};

export const formatNigerianPhone = (phone) => {
  if (!phone) return "";

  let digits = String(phone).trim().replace(/\s+/g, "").replace(/^\+/, "");

  if (digits.startsWith("0")) {
    digits = "234" + digits.slice(1);
  } else if (!digits.startsWith("234")) {
    digits = "234" + digits;
  }

  return `+${digits}`;
};
